import React from "react";
import "./Loader.scss";

const Loader = () => {
  return <div class="loader">Loading...</div>;
};

export default Loader;
